@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.fcm

import com.narbase.letsgo.router.EndPoint

object UpdatePassengerFcmTokenEndpoint :
    EndPoint<UpdatePassengerFcmTokenEndpoint.Request, UpdatePassengerFcmTokenEndpoint.Response>() {
    class Request(
        val fcmToken: String,
        val isAndroid: Boolean
    )

    class Response
}